/* eslint-disable react-hooks/exhaustive-deps */
import { useEffect, useRef, useState } from "react";
import ContainerFlex from "components/ContainerFlex";
import * as St from "./styles";
import AppButton from "components/AppButton/AppButton";
import { RouteNames } from "routes/routes";
import { useHistory, useLocation } from "react-router-dom";
import { useAppDispatch, useAppSelector } from "redux/app/hooks";
import { addTypeFlowState } from "redux/features/security/security-slice";
import ReactToPrint from "react-to-print";
import useApi, { ApiMethod } from "hooks/useApi";
import Endpoints from "services/api/endpoints";
import { setLoading, setTitleLoading } from "redux/ui/loadings-slice";
import { showMessage } from "utils/messages";
import { hideEmailMask } from "utils/mask";
import PrintPaymentPixVoucher from "../components/PrintPaymentPixVoucher";
import Swal, { SweetAlertIcon, SweetAlertOptions } from "sweetalert2";

export const showMessageAndWait = (
  type: SweetAlertIcon,
  title: string,
  message: string,
  props?: SweetAlertOptions
) => {
  return Swal.fire({
    icon: type,
    title,
    text: message,
    ...props,
  });
};

const ProofPayment: React.FC = () => {
  const [voucher, setVoucher] = useState<any | undefined>(undefined);
  const history = useHistory();
  const dispatch = useAppDispatch();
  const componentRef = useRef<HTMLIFrameElement>(null);

  const {
    cliente: { email, nome },
  } = useAppSelector((state) => state.cliente);

  const { state } = useLocation<any>();

  const { txid, idFatura } = state;

  // const GetPaymentVoucher = useApi<any>(
  //   Endpoints.cobranca.getPaymentVoucherPix.replace("PARAM_ID_TX", txid),
  //   ApiMethod.GET
  // );

  const getPaymentInvoiceVoucher = useApi<any>(
    Endpoints.cobranca.getInvoicePaymentVoucher.replace(
      "PARAM_ID_FATURA",
      idFatura
    ),
    ApiMethod.GET
  );

  const PostSendPaymentVoucherEmail = useApi<any>(
    Endpoints.cobranca.postSendPaymentVoucherEmail.replace("PARAM_ID_TX", txid),
    ApiMethod.POST
  );

  const PostSendPaymentAntecipationVoucherEmail = useApi<any>(
    Endpoints.cobranca.postSendPaymentVocuherAntecipationEmail,
    ApiMethod.POST
  );

  const GetPaymentAntecipationVoucher = useApi(
    Endpoints.cobranca.getPaymentAntecipation.replace("PARAM_TXID", txid),
    ApiMethod.GET
  );

  const getPaymentAntecipationVoucher = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Gerando comprovante..."));

    try {
      const response = await GetPaymentAntecipationVoucher.callApi();
      if (response.status >= 200 && response.status < 300) {
        setVoucher(response?.data);
        console.log(response.data);
      }

      if (response.status >= 400) {
        dispatch(setLoading(false));
        const mensagem =
          response.data &&
          typeof response.data === "object" &&
          "mensagem" in response.data
            ? (response.data as { mensagem: string }).mensagem
            : "Ocorreu um erro desconhecido.";
        showMessage("warning", "Atenção", mensagem);
        history.push(RouteNames.ATENDIMENTO_FATURA);
      }
      dispatch(setLoading(false));
    } catch (error) {
      console.error("Erro ao gerar comprovante:", error);
    }
  };

  const getPaymentVoucherPix = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Gerando comprovante..."));

    try {
      const response = await getPaymentInvoiceVoucher.callApi();
      if (response.status >= 200 && response.status <= 300) {
        setVoucher(response?.data);
      }

      if (response.status >= 400) {
        dispatch(setLoading(false));
        const { mensagem } = response.data;
        showMessage("warning", "Atenção", mensagem);
        history.push(RouteNames.ATENDIMENTO_FATURA);
      }
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };

  const handlePaymentVoucherPixAntecipationSendEmail = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Enviando e-mail..."));

    const payload = {
      email,
      nome,
      nomeArquivo: txid,
    };

    const response = await PostSendPaymentAntecipationVoucherEmail.callApi(
      payload
    );

    try {
      if (response.status >= 200 && response.status <= 300) {
        dispatch(setLoading(false));
        await showMessageAndWait("success", "E-mail enviado", hideEmailMask(email));
        history.push(RouteNames.HOME);    
      }

      if (response.status >= 400) {
        dispatch(setLoading(false));
        const { mensagem } = response.data;
        showMessage("warning", "Atenção", mensagem);
        history.push(RouteNames.HOME);
      }
    } catch (error) {}
  };

  const handlePaymentVoucherPixSendEmail = async () => {
    dispatch(setLoading(true));
    dispatch(setTitleLoading("Enviando e-mail..."));

    try {
      const response = await PostSendPaymentVoucherEmail.callApi();

      if (response.status >= 200 && response.status <= 300) {
        dispatch(setLoading(false));
        showMessage("success", "E-mail enviado", hideEmailMask(email));
        history.push(RouteNames.HOME);
      }

      if (response.status >= 400) {
        dispatch(setLoading(false));
        const { mensagem } = response.data;
        showMessage("warning", "Atenção", mensagem);
        history.push(RouteNames.HOME);
      }
      dispatch(setLoading(false));
    } catch (error) {
      console.log(error);
      dispatch(setLoading(false));
    }
  };

  const clickBack = () => {
    history.push(RouteNames.ATENDIMENTO_HOME);
    dispatch(addTypeFlowState("fatura"));
  };

  useEffect(() => {
    if (idFatura && !state.antecipation) {
      getPaymentVoucherPix();
    }

    if (txid && state?.antecipation) {
      getPaymentAntecipationVoucher();
    }
  }, [idFatura, txid]);

  return (
    <ContainerFlex>
      <St.TitleH1>Comprovante</St.TitleH1>
      <ContainerFlex>
        <ContainerFlex center>
          <St.SpanDescription>Pagamento realizado!</St.SpanDescription>
        </ContainerFlex>
        <ContainerFlex center marginBottom={10}>
          <ContainerFlex center>
            <ContainerFlex
              padding={15}
              color="#fbfbfb"
              width={60}
              height={50}
              maxWidth={100}
              maxHeight={350}
              scroll
              hidden
            >
              <div ref={componentRef}>
                {/* <iframe
                src={`data:application/pdf;base64,${voucher}#toolbar=0&navpanes=0&view=FitH&zoom=150`}
                style={{ border: "none !important", height: 280, width: 700 }}
                title="Comprovante PIX"
              /> */}
                <PrintPaymentPixVoucher
                  data={voucher}
                  antecipation={state.antecipation}
                />
              </div>
            </ContainerFlex>
          </ContainerFlex>
          <ContainerFlex center padding={2}></ContainerFlex>
        </ContainerFlex>
      </ContainerFlex>
      <ContainerFlex center horizontal row space marginBottom={30}>
        <AppButton
          content="Voltar"
          route={RouteNames.ATENDIMENTO_HOME}
          outlined={true}
          click={clickBack}
        />

        <AppButton
          content="Enviar por e-mail"
          click={
            state?.antecipation
              ? handlePaymentVoucherPixAntecipationSendEmail
              : handlePaymentVoucherPixSendEmail
          }
        />

        <ReactToPrint
          trigger={() => <button className="normal">Imprimir</button>}
          content={() => componentRef.current}
        />
      </ContainerFlex>
    </ContainerFlex>
  );
};

export default ProofPayment;
